import React from 'react';
import ConfirmCancel from 'components/legacy/Dialogs/ConfirmCancel';
import { useForm } from '../../LWForm/LWForm';

/**
 * Dialog actions to be used within context of LWForm
 * @param {import('components/legacy/Dialogs/ConfirmCancel/ConfirmCancel').ConfirmCancelI} props
 */
const HookedConfirmCancel = ({ disabled, confirmType, ...rest }) => {
	const { isValid } = useForm();

	return (
		<ConfirmCancel
			confirmType="submit"
			disabled={!isValid || disabled}
			{...rest}
		/>
	);
};

export default HookedConfirmCancel;
